import React from "react";

import "../assets/scss/about-tab.scss";

export const AboutTab: React.FC = () => {
  return (
    <div className="about-tab">
      <p>about</p>
    </div>
  );
};
